import React from "react";
import BinningPage from "../components/Binning/BinningPage";

function Binning() {
  return (
    <div className="mt-5 space-y-5">
      <div className="w-full text-center border-b-2 pb-2">
        <div className="font-semibold" style={{ color: "#808080" }}>
          Binning
        </div>
      </div>
      <BinningPage />
    </div>
  );
}

export default Binning;
